import React, { useEffect, useMemo, useState } from 'react'
import { const_var, params } from '../../../../../redux/reducers/reducer'
import WallNameTemplete from '../../../WallName/WallNameTemplete';

const WallName = () => {
    const [porchOffset, setPorchOffset] = useState(0);

    const frontLeftPosState = useMemo(() => {
        let offset = false;
        if((params.leanF_p_w && params.lean_p_w) < 9) {
            if((params.leanF_p_pos - params.leanF_p_d / 2 - 2.5 < -params.p_w / 2 - 1) && (params.lean_p_pos + params.lean_p_d / 2 + 2.5 > params.p_d / 2 + 1)){
                offset = true;
            }
        }
        
        return offset;
    }, [params.leanF_p_pos, params.leanF_p_d, params.p_w, params.lean_p_pos, params.lean_p_d, params.p_d, params.leanF_p_w, params.lean_p_w])

    const backLeftPosState = useMemo(() => {
        let offset = false;
        if((params.leanB_p_w && params.lean_p_w) < 9) {
            if((params.leanB_p_pos - params.leanB_p_d / 2 - 2.5 < -params.p_w / 2 - 1) && (params.lean_p_pos - params.lean_p_d / 2 - 2.5 < -(params.p_d / 2 + 1))){
                offset = true;
            }
        }
        
        return offset;
    }, [params.leanB_p_pos, params.leanB_p_d, params.p_w, params.lean_p_pos, params.lean_p_d, params.p_d, params.leanB_p_w, params.lean_p_w])

    useEffect(() => {
        if(params.add_left_front_lean_porch && !params.add_left_back_lean_porch) {
            setPorchOffset(params.leanF_p_w / 2)
        } else if(!params.add_left_front_lean_porch && params.add_left_back_lean_porch){
            setPorchOffset(-params.leanB_p_w / 2)
        } else {
            setPorchOffset(0)
        }
    }, [params.add_left_front_lean_porch, params.add_left_back_lean_porch, params.leanF_p_w, params.leanB_p_w])


    let wallTemplates = [
        { position: [-(params.p_w / 2 + params.lean_p_w + 1), 0, porchOffset], rotation: [0, -Math.PI / 2, 0], slopeAngle: 60, value: 'Left Lean Side' },
        { position: [-(params.p_w / 2 + params.lean_p_w / 2), frontLeftPosState ? 0.7 : 0, params.lean_p_d / 2 + (frontLeftPosState ? -0.5 : 1)], rotation: [0, 0, 0], slopeAngle: (frontLeftPosState ? 0 : 60), value: 'Left Lean Front' },
        { position: [-(params.p_w / 2 + params.lean_p_w / 2), backLeftPosState ? 0.7 : 0, -(params.lean_p_d / 2 + (backLeftPosState ? -0.5 : 1))], rotation: [0, Math.PI, 0], slopeAngle: (backLeftPosState ? 0 : 60), value: 'Left Lean Back' }
    ]   
    if(params.add_storage_check){
        let positionZ = -(params.lean_p_d / 2  - parseInt(params.add_storage));
        let leftStorage = {
             position: [-(params.p_w / 2 + params.lean_p_w / 2), 0, positionZ], 
             rotation: [0, 0, 0], 
             slopeAngle: 60,
             value: 'Left Lean Storage Front' 
            };

        wallTemplates = [...wallTemplates,leftStorage]
    }
    return (
        <>
            {wallTemplates.map((template, index) => (
                <WallNameTemplete
                    key={index}
                    position={template.position}
                    rotation={template.rotation}
                    value={template.value}
                    slopeAngle={template.slopeAngle}
                />
            ))}
        </>
    )
}

export default WallName